import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center bg-[#F5F3F0]"
            >
                <div className="text-[#0033CC] font-heading text-lg">Loading…</div>
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/admin/login" replace />;
    }
    return children;
}
